import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from '@finder/core/config.service';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';

import isEmpty from 'lodash-es/isEmpty';
import { FONT_ICON_FORMAT, FONT_ICON_SVG_FALLBACK } from './font-icon.constants';

/**
 * Creates a font-icon. For semantic icons, please add extra
 * markup to provide guidance to guests with visual disabilities.
 *
 * @example <finder-font-icon name="all-activities" title="All Activities" size="m"></finder-font-icon>
 * @param name string The icon's name. These can be found at [WDW]{@link https://disneyworld.disney.go.com/debug/web-font/}
 * @param size string The size of the icon. Values: xxs|xs|s|m|l|xl. Leave this param empty to inherit the font-size property.
 * @param title string The title of the icon. Used to show a tooltip upon hovering the icon.
 * @param hexValue string The hexCharacter of the icon.
 */

@Component({
    selector: 'finder-font-icon',
    templateUrl: './font-icon.component.html',
    styleUrls: ['./font-icon.component.scss']
})
export class FontIconComponent implements OnInit {
    styles: any;
    imgSrc: string;
    format: string = FONT_ICON_FORMAT.FONT;
    FORMATS = FONT_ICON_FORMAT;

    @Input() public color: string;
    @Input() public name: string;
    @Input() public size: string;
    @Input() public title: string;
    @Input() public hexValue: string;
    @Input() public svg = false;
    @Input() public svgSrc: string;
    @Input() public ariaHidden = true;
    @Input() public htmlEntity = ''; // Needs to be initialized since it is HTML bound

    constructor(
        private configService: ConfigService,
    ) {}

    ngOnInit() {
        // Defaulting Inputs
        this.name = isEmpty(this.name) ? 'all-parks-and-resorts' : this.name;
        this.name = this.hexValue || this.name;
        this.size = isEmpty(this.size) ? 'inherit' : this.size;
        this.title = isEmpty(this.title) ? null : this.title;

        if (this.color) {
            this.styles = {
                'color': this.color
            };
        }

        // Remove the name if we are passed an HTML entity
        if (this.htmlEntity) {
            this.name = '';
        }

        // Check for SVG support
        if (this.svg && (this.svgSrc || this.name)) {
            this.setUpSvg();
        }
    }

    private setUpSvg() {
        this.format = FONT_ICON_FORMAT.ICON;

        // if the src is provided, we apply it directly
        if (this.svgSrc) {
            this.imgSrc = this.svgSrc;
            return;
        }

        this.imgSrc = `${this.configService.getCdnUrl()}${this.configService.getValue(CONFIG_CONSTANTS.svgPathKey)}/${this.name}.svg`;
    }
}
